import type { ReactNode } from 'react';

export const symbol_send_and_archive: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m675-213-67-67q-5-5-10-5t-10 5q-5 5-5 10.5t5 10.5l81 82q9 9 21 9t21-9l82-82q5-5 5-10.5t-5-10.5q-5-5-10.5-5t-10.5 5l-67 67v-156q0-6-4.5-10.5T690-384q-6 0-10.5 4.5T675-369v156Zm-555 8v-550q0-16.13 13.5-24.57Q147-788 162-782l497 209q14 6 17.5 17.5T675-533q-5 11-15 16t-24-1L180-710v168l156 40q8 2.37 12 8.68 4 6.32 4 13.54 0 7.22-4.5 13T335-459l-155 39v167l223-93q14-6 25.05-.31Q439.09-340.62 444-330q5 11 1 23t-18 18L162-178q-15 6-28.5-2.43Q120-188.87 120-205Zm436 69.6q-56-55.4-56-134T556-404q56-56 134-56t134 55.87q56 55.86 56 135.13 0 78.43-56 133.72Q768-80 690-80t-134-55.4ZM381-482Z"
		/>
	</svg>
);
